// export default {
//     "Capital Federal": [],
//     "Buenos Aires": [],
//     "Catamarca": [],
//     "Córdoba": [],
//     "Corrientes": [],
//     "Chaco": [],
//     "Chubut": [],
//     "Entre Ríos": [],
//     "Formosa": [],
//     "Jujuy": [],
//     "La Pampa": [],
//     "La Rioja": [],
//     "Mendoza": [],
//     "Misiones": [],
//     "Neuquén": [],
//     "Río Negro": [],
//     "Salta": [],
//     "San Juan": [],
//     "San Luis": [],
//     "Santa Cruz": [],
//     "Santa Fe": [],
//     "Santiago del Estero": [],
//     "Tierra del Fuego": [],
//     "Tucumán": []
// }
export default {
    "Almería": [],
    "Cádiz": [],
    "Córdoba": [],
    "Granada": [],
    "Huelva": [],
    "Jaén": [],
    "Málaga": [],
    "Sevilla": [],
    "Huesca": [],
    "Teruel": [],
    "Zaragoza": [],
    "Asturias": [],
    "Balears, Illes": [],
    "Palmas, Las": [],
    "Santa Cruz de Tenerife": [],
    "Cantabria": [],
    "Ávila": [],
    "Burgos": [],
    "León": [],
    "Palencia": [],
    "Salamanca": [],
    "Segovia": [],
    "Soria": [],
    "Valladolid": [],
    "Zamora": [],
    "Albacete": [],
    "Ciudad Real": [],
    "Cuenca": [],
    "Guadalajara": [],
    "Toledo": [],
    "Barcelona": [],
    "Girona": [],
    "Lleida": [],
    "Tarragona": [],
    "Alicante/Alacant": [],
    "Castellón/Castelló": [],
    "Valencia/València": [],
    "Badajoz": [],
    "Cáceres": [],
    "Coruña, A": [],
    "Lugo": [],
    "Ourense": [],
    "Pontevedra": [],
    "Madrid": [],
    "Murcia": [],
    "Navarra": [],
    "Araba/Álava": [],
    "Bizkaia": [],
    "Gipuzkoa": [],
    "Rioja, La": [],
    "Ceuta": [],
    "Melilla": []
}